module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Place of worship-7c2ce86985b7c1c2976bcd3dd6537abb.png";